import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const PaymentDeniedIcon: React.FC<SvgProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101"
        height="120"
        viewBox="0 0 101 120"
        fill="none"
    >
        <path
            d="M97.3729 2.17773H22.3379V100.808H97.3729V2.17773Z"
            fill="white"
            stroke="#FF6464"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M87.5101 12.0391H12.4751V110.669H87.5101V12.0391Z"
            fill="white"
            stroke="#FF6464"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M77.6447 21.9023H2.61182V117.445H77.6447V21.9023Z"
            fill="white"
            stroke="#192B4D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M18.8857 87.6504H61.1981"
            stroke="#192B4D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M18.8857 99.4883H43.9755"
            stroke="#192B4D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M39.9917 74.4707C51.1032 74.4707 60.1109 65.4631 60.1109 54.3516C60.1109 43.2401 51.1032 34.2324 39.9917 34.2324C28.8802 34.2324 19.8726 43.2401 19.8726 54.3516C19.8726 65.4631 28.8802 74.4707 39.9917 74.4707Z"
            stroke="white"
            stroke-width="9.86301"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M39.9917 74.4707C51.1032 74.4707 60.1109 65.4631 60.1109 54.3516C60.1109 43.2401 51.1032 34.2324 39.9917 34.2324C28.8802 34.2324 19.8726 43.2401 19.8726 54.3516C19.8726 65.4631 28.8802 74.4707 39.9917 74.4707Z"
            stroke="#FF6464"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M31.1826 59.7344C33.848 58.4377 36.8324 57.707 39.9918 57.707C42.7704 57.707 45.4152 58.273 47.8234 59.2919"
            stroke="#FF6464"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M47.9629 51.8809L51.9081 52.8672"
            stroke="#FF6464"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M31.1957 51.8809L27.2505 52.8672"
            stroke="#FF6464"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export default PaymentDeniedIcon;
